import React from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { useHistory, Link } from 'react-router-dom';
import {
  Navbar as BootstrapNavbar,
  Nav,
  Dropdown,
  Spinner
} from 'react-bootstrap';
import { useQuery } from '@apollo/react-hooks';
import { VIEW_REG_CASES_BY_USER } from "../Queries";
import Logo from "../logo.gif";

const Navbar = ({ isAdmin, userInfo }) => {
  const { 
    isAuthenticated, 
    logout, 
    user 
  } = useAuth0();

  const history = useHistory();
  /* Grab all Registrations related to this user */
  const userEmail = Boolean(userInfo) ? userInfo.email : null;
  const { loading, error, data } = useQuery(VIEW_REG_CASES_BY_USER, { 
    variables: { userEmail: userEmail }, 
    fetchPolicy: 'network-only'
  });

  const handleLogout = () => {
    const returnTo = process.env.REACT_APP_TEST_MODE === "true"
      ? 'https://staging.rdfs.ethics.lacity.gov'
      : 'https://rdfs.ethics.lacity.gov';

    logout({
      logoutParams: {
        returnTo: returnTo
      }
    });
  };

  if (!userInfo || loading) {
    return <Spinner animation="border" variant="light" size="sm" />;
  }

  if (error) {
    console.error(`Retrieve error! ${error}`);
    return null;
  }

  const caseRegistrations = data.getCaseRegByUser;
  const caseRegistrationsInProgress = caseRegistrations.filter(
    (caseReg) => caseReg.document_status_id == 0 || caseReg.document_status_id == 1
  );
  const caseRegistrationsCompleted = caseRegistrations.filter(
    (caseReg) => caseReg.document_status_id > 1
  );

  return (
    <>
      <BootstrapNavbar 
        style={{ 
          backgroundColor: '#0fa7cd',
          padding: '10px 25px'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          {/* Left: Logo */}
          <Link to="/Home">
            <img 
              src={Logo} 
              alt="Ethics Commission Logo" 
              style={{ height: '50px' }}
            />
          </Link>

          {/* Center: Title */}
          <div style={{ 
            flex: 1, 
            textAlign: 'center',
            color: 'white',
            fontSize: '32px',
            fontWeight: 'normal'
          }}>
            Restricted Developer Filing System
          </div>

          {/* Right: Navigation */}
          <Nav>
            {isAuthenticated && (
              <>
                {/* User Dropdown */}
                <Dropdown align="end">
                  <Dropdown.Toggle 
                    variant="link" 
                    id="user-dropdown"
                    style={{ 
                      color: 'white', 
                      textDecoration: 'none',
                      paddingLeft: '20px'
                    }}
                  >
                    {user?.given_name || 'User'}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item as={Link} to="/SelectCase">
                      Register New
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    
                    {/* Conditional Registration Items */}
                    {caseRegistrationsInProgress.length > 0 && (
                      <Dropdown.Item as={Link} to="/Registrations/InProgress">
                        In Progress ({caseRegistrationsInProgress.length})
                      </Dropdown.Item>
                    )}
                    {caseRegistrationsCompleted.length > 0 && (
                      <Dropdown.Item as={Link} to="/Registrations/Complete">
                        Completed ({caseRegistrationsCompleted.length})
                      </Dropdown.Item>
                    )}

                    {(caseRegistrationsInProgress.length > 0 || 
                      caseRegistrationsCompleted.length > 0) && <Dropdown.Divider />}

                    {isAdmin && (
                      <>
                        <Dropdown.Item as={Link} to="/Admin">
                          Admin Menu
                        </Dropdown.Item>
                        <Dropdown.Divider />
                      </>
                    )}
                    <Dropdown.Item onClick={handleLogout}>
                      Logout
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </>
            )}
          </Nav>
        </div>
      </BootstrapNavbar>
      
    </>
  );
};

export default Navbar;
